import * as definitions from 'store/definitions/customer';

export function createCustomer(payload) {
  return {
    type: definitions.CREATE_CUSTOMER,
    payload,
  };
}
